// extracted by mini-css-extract-plugin
export default {"paginationWrapper":"Pagination_paginationWrapper__73BUg","prevBtn":"Pagination_prevBtn__7XQJ7","nextBtn":"Pagination_nextBtn__g3Zr2","activeBtn":"Pagination_activeBtn__hKZYp"};